var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReportPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_22819",
    "data-name": "\\uADF8\\uB8F9 22819",
    transform: "translate(-1841 -47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pdf"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_6028",
    "data-name": "\\uC0AC\\uAC01\\uD615 6028",
    width: 16,
    height: 19,
    transform: "translate(1841 47)",
    fill: "#fc522f"
  }), /*#__PURE__*/React.createElement("text", {
    id: "PDF-2",
    "data-name": "PDF",
    transform: "translate(1849 59)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "MalgunGothicBold, Malgun Gothic",
    letterSpacing: "-0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7,
    y: 0
  }, "PDF"))), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7768",
    "data-name": "\\uD328\\uC2A4 7768",
    d: "M0,0H3L0,3Z",
    transform: "translate(1853 62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7769",
    "data-name": "\\uD328\\uC2A4 7769",
    d: "M3,3H0L3,0Z",
    transform: "translate(1854 63)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReportPdf);
export default __webpack_public_path__ + "static/media/icon-report-pdf.f99ab55b.svg";
export { ForwardRef as ReactComponent };